import { render, staticRenderFns } from "./KrakenExchangeInput.vue?vue&type=template&id=25f973cc&"
import script from "./KrakenExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./KrakenExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports